<template>
	<b-button v-if="isDirty" :variant="activeTemplate ? 'warning' : 'success'" class="float-right ml-1" tabindex="3" @click="onSaveTemplate">{{ activeTemplate ? 'Update Template' : 'Create Template'}}</b-button>
</template>
<script>
import FormExtension from "@/core/components/FormExtension"
import { mapGetters, mapState, mapActions } from "vuex"

export default FormExtension.extend({
    name: "prescriptions-template-button",
    data() {
        return {
            form: new Form({
                medication_id: null,
                other: "",
                dosage: {
                    medication_id: null,
                    other: "",
                    is_chronic: false,
                    repeat_prescription: 0,
                    repeat_date_id: null,
                    strength: null,
                    unit_id: null,
                    frequency_usage: null,
                    frequency_unit_id: null,
                    dosage_amount: null,
                    dosage_form_id: null,
                    amount_of_time: null,
                    delivery_form_id: null,
                    instructions: "",
                },
                consistency_token: null
            }),

            activeTemplate: null
        }
    },
    watch: {
        form: {
            deep: true,
            handler(val) {
                this.isDirty = this.form.dirty()
            }
        }
    },
    methods: {
        ...mapActions('prescriptions', ['createPrescriptionTemplate', 'updatePrescriptionTemplate']),
        prepareTemplate(data) {
	        // When data comes from PrescriptionsForm, fields are at top level
	        // When data comes from API (saved template), fields are in dosage object
	        const isFromApi = data?.dosage && typeof data.dosage === 'object';
	        
	        this.form.populate({
	            medication_id: data?.medication_id,
	            other: data?.other,
	            dosage:{
	                medication_id: data?.medication_id,
	                other: data?.other,
	                is_chronic: isFromApi ? data.dosage?.is_chronic : (data?.is_chronic || false),
	                repeat_prescription: isFromApi ? data.dosage?.repeat_prescription : (data?.repeat_prescription || 0),
	                repeat_date_id: isFromApi ? data.dosage?.repeat_date_id : (data?.repeat_date_id || null),
	                strength: isFromApi ? data.dosage?.strength : data?.strength,
	                unit_id: isFromApi ? data.dosage?.unit_id : data?.unit_id,
	                frequency_usage: isFromApi ? data.dosage?.frequency_usage : data?.frequency_usage,
	                frequency_unit_id: isFromApi ? data.dosage?.frequency_unit_id : data?.frequency_unit_id,
	                dosage_amount: isFromApi ? data.dosage?.dosage_amount : data?.dosage_amount,
	                dosage_form_id: isFromApi ? data.dosage?.dosage_form_id : data?.dosage_form_id,
	                amount_of_time: isFromApi ? data.dosage?.amount_of_time : data?.amount_of_time,
	                delivery_form_id: isFromApi ? data.dosage?.delivery_form_id : data?.delivery_form_id,
	                instructions: isFromApi ? data.dosage?.instructions : data?.instructions,
	            }
	        })
        },
        loadFromSavedTemplate(val) {
        	this.activeTemplate = val
            this.prepareTemplate(val)
        },
        reset() {
            this.form.reset()
            this.activeTemplate = null
        },
        onSaveTemplate() {
            const formData = this.form.data()
            console.log('Saving template with data:', formData)
            console.log('Dosage strength:', formData.dosage?.strength)
            console.log('Dosage unit_id:', formData.dosage?.unit_id)
            console.log('Active template:', this.activeTemplate)
            
            // Check if strength/unit has changed from the active template
            const currentStrength = formData.dosage?.strength
            const currentUnitId = formData.dosage?.unit_id
            const originalStrength = this.activeTemplate?.dosage?.strength
            const originalUnitId = this.activeTemplate?.dosage?.unit_id
            
            const hasStrengthChanged = this.activeTemplate && (
                currentStrength !== originalStrength ||
                currentUnitId !== originalUnitId
            )
            
            console.log('Strength comparison:', {
                currentStrength,
                currentUnitId,
                originalStrength,
                originalUnitId,
                hasStrengthChanged
            })
            
            // If there's an active template but strength hasn't changed, update it
            // Otherwise, create a new template (including when strength changes)
            if (this.activeTemplate && !hasStrengthChanged) {
                this.updatePrescriptionTemplate({id: this.activeTemplate?.id, data: formData }).then((template) => {
                    console.log('Template updated, received:', template)
                    this.prepareTemplate(template)
                    
                    EventBus.$emit('prescription-get-templates')

                    this.notify("Prescription template updated", "Prescription template was updated successfully")
                })
                .catch(errors => {
                    if (errors.response) {
                        this.$refs.observer?.setErrors(errors.response.data)
                        this.hasErrors = true
                    }
                })
            }else{
                this.createPrescriptionTemplate(formData).then((template) => {
                    console.log('Template created, received:', template)
                    this.loadFromSavedTemplate(template)
                    
                    EventBus.$emit('prescription-get-templates')
                    
                    const message = this.activeTemplate && hasStrengthChanged 
                        ? "New template created with different strength" 
                        : "Prescription template was created successfully"
                    this.notify("Prescription template created", message)
                })
                .catch(errors => {
                    if (errors.response) {
                        this.$refs.observer?.setErrors(errors.response.data)
                        this.hasErrors = true
                    }
                })
            }
        }
    },
    mounted() {
    	EventBus.$on('prescription-template-loaded-from-template', (template) => {
            this.loadFromSavedTemplate(template)
        })

        EventBus.$on('prescription-reset-template', () => {
            this.reset()
        })
    },
    beforeDestroy() {
         EventBus.$off("prescription-template-loaded-from-template")
         EventBus.$off("prescription-reset-template")
    }
})
</script>